import { apiRequest } from "./api";
import { getFeedbackSessionId } from "./feedbackSession";

const KEY = "theofast-feedback-watch";
export function getFeedbackWatch() {
  try { return JSON.parse(window.localStorage.getItem(KEY)) || {}; } catch { return {}; }
}
export function adminReplyTime(post) {
  return Math.max(0, Date.parse(post.adminReply?.updatedAt) || 0, ...(post.replies || []).filter(reply => reply.role === "admin").map(reply => Date.parse(reply.createdAt) || 0));
}
export function watchFeedback(post, read = false) {
  if (!post?.id) return;
  const watch = getFeedbackWatch();
  watch[post.id] = read ? adminReplyTime(post) : (watch[post.id] || 0);
  try {
    window.localStorage.setItem(KEY, JSON.stringify(Object.fromEntries(Object.entries(watch).slice(-100))));
    window.dispatchEvent(new Event("theofast-feedback-updated"));
  } catch { /* Notifications require browser storage; posting does not. */ }
}
export async function loadFeedbackUpdates() {
  const watch = getFeedbackWatch();
  const sessionId = getFeedbackSessionId();
  const result = await apiRequest("/api/theofast/feedback/updates", { method: "POST", body: JSON.stringify({ sessionId, postIds: Object.keys(watch).slice(-100) }) });
  return (result.posts || []).filter(post => adminReplyTime(post) > (Number(watch[post.id]) || 0));
}
